export default __webpack_public_path__ + "static/media/seasonpass_hd.fe2a0e62.webp";